module.exports = __webpack_public_path__ + "static/img/app_instant_flow.92f994a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/images/app_instant_flow.png
// module id = YCSe
// module chunks = 8